import { useMutation } from 'react-query';

import { http, camelCaseToUnderscore, underscoreToCamelCase } from '../base/http';
import type { LinkedLayer } from '../types/linked-layer';

export const useCreateLinkedLayer = (args: Record<string, unknown> = {}) => {
    return useMutation({
        mutationFn: (layer: LinkedLayer) =>
            http.post<LinkedLayer>('/linked_layers', camelCaseToUnderscore(layer)).then(underscoreToCamelCase),
        ...args,
    });
};

export const useDeleteLinkedLayer = (args: Record<string, unknown> = {}) => {
    return useMutation({
        mutationFn: (id: number) => http.delete<void>(`/linked_layers/${id}`),
        ...args,
    });
};
